export default {"src":"/_next/static/media/infoCircle.4263d3f3.svg","height":28,"width":28};